import { useState, useEffect } from 'react';

export function useTrustedForm() {
  const [trustedformCert, setTrustedformCert] = useState('');
  const [trustedformPingUrl, setTrustedformPingUrl] = useState('');

  useEffect(() => {
    let certCaptured = false;
    let pingCaptured = false;

    const poll = () => {
      if (!certCaptured) {
        const el = document.querySelector('[name="xxTrustedFormCertUrl"]');
        if (el?.value) {
          certCaptured = true;
          setTrustedformCert(el.value);
        }
      }
      if (!pingCaptured) {
        const el = document.querySelector('[name="xxTrustedFormPingUrl"]');
        if (el?.value) {
          pingCaptured = true;
          setTrustedformPingUrl(el.value);
        }
      }
      return certCaptured && pingCaptured;
    };

    if (poll()) return;

    const id = setInterval(() => {
      if (poll()) clearInterval(id);
    }, 500);

    return () => clearInterval(id);
  }, []);

  return { trustedformCert, trustedformPingUrl };
}
